export const latlongIndonesia = [
  {
    name: "Aceh",
    latitude: 5.5483,
    longitude: 95.3238,
  },
  {
    name: "Sumatera Utara",
    latitude: 2.1154,
    longitude: 99.5451,
  },
  {
    name: "Sumatera Barat",
    latitude: -0.9492,
    longitude: 100.3543,
  },
  {
    name: "Riau",
    latitude: 0.5071,
    longitude: 101.4478,
  },
  {
    name: "Kepulauan Riau",
    latitude: 3.9457,
    longitude: 108.1429,
  },
  {
    name: "Jambi",
    latitude: -1.6101,
    longitude: 103.6131,
  },
  {
    name: "Sumatera Selatan",
    latitude: -3.3194,
    longitude: 104.9147,
  },
  {
    name: "Bangka Belitung",
    latitude: -2.7411,
    longitude: 106.4406,
  },
  {
    name: "Bengkulu",
    latitude: -3.7928,
    longitude: 102.2601,
  },
  {
    name: "Lampung",
    latitude: -4.5586,
    longitude: 105.4068,
  },
  {
    name: "DKI Jakarta",
    latitude: -6.2088,
    longitude: 106.8456,
  },
  {
    name: "Jawa Barat",
    latitude: -6.8892,
    longitude: 107.6405,
  },
  {
    name: "Banten",
    latitude: -6.4058,
    longitude: 106.064,
  },
  {
    name: "Jawa Tengah",
    latitude: -7.1509,
    longitude: 110.1403,
  },
  {
    name: "DI Yogyakarta",
    latitude: -7.7956,
    longitude: 110.3695,
  },
  {
    name: "Jawa Timur",
    latitude: -7.5361,
    longitude: 112.2384,
  },
  {
    name: "Bali",
    latitude: -8.3405,
    longitude: 115.092,
  },
  {
    name: "Nusa Tenggara Barat",
    latitude: -8.6529,
    longitude: 117.3616,
  },
  {
    name: "Nusa Tenggara Timur",
    latitude: -9.0096,
    longitude: 124.828,
  },
  {
    name: "Kalimantan Barat",
    latitude: -0.1322,
    longitude: 111.0962,
  },
  {
    name: "Kalimantan Tengah",
    latitude: -1.6815,
    longitude: 113.3824,
  },
  {
    name: "Kalimantan Selatan",
    latitude: -3.0006,
    longitude: 115.2838,
  },
  {
    name: "Kalimantan Timur",
    latitude: 0.5387,
    longitude: 116.4194,
  },
  {
    name: "Kalimantan Utara",
    latitude: 3.0731,
    longitude: 116.0414,
  },
  {
    name: "Sulawesi Utara",
    latitude: 1.43,
    longitude: 124.9832,
  },
  {
    name: "Sulawesi Tengah",
    latitude: -1.43,
    longitude: 120.8332,
  },
  {
    name: "Sulawesi Selatan",
    latitude: -3.6688,
    longitude: 119.9741,
  },
  {
    name: "Sulawesi Tenggara",
    latitude: -4.1449,
    longitude: 122.1746,
  },
  {
    name: "Gorontalo",
    latitude: 0.5435,
    longitude: 123.0567,
  },
  {
    name: "Sulawesi Barat",
    latitude: -2.8441,
    longitude: 119.2321,
  },
  {
    name: "Maluku",
    latitude: -3.2385,
    longitude: 130.1453,
  },
  {
    name: "Maluku Utara",
    latitude: 0.7852,
    longitude: 127.3676,
  },
  {
    name: "Papua",
    latitude: -4.2699,
    longitude: 138.0803,
  },
  {
    name: "Papua Barat",
    latitude: -1.3361,
    longitude: 133.1747,
  },
  {
    name: "Papua Tengah",
    latitude: -3.8611,
    longitude: 137.3897,
  },
  {
    name: "Papua Pegunungan",
    latitude: -3.9227,
    longitude: 138.1771,
  },
  {
    name: "Papua Selatan",
    latitude: -6.1359,
    longitude: 139.9645,
  },
  {
    name: "Papua Barat Daya",
    latitude: -1.9174,
    longitude: 131.2893,
  },
];
